import { render, staticRenderFns } from "./GeneralCourse.vue?vue&type=template&id=6692d5c0&scoped=true&"
import script from "./GeneralCourse.vue?vue&type=script&lang=js&"
export * from "./GeneralCourse.vue?vue&type=script&lang=js&"
import style0 from "./GeneralCourse.vue?vue&type=style&index=0&id=6692d5c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6692d5c0",
  null
  
)

export default component.exports